import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./types.gen";

// Re-export types for browser consumers
export type { Session, User } from "@supabase/supabase-js";

export type SupabaseBrowserClient = SupabaseClient<Database>;

let browserClient: SupabaseBrowserClient | null = null;

function getBrowserEnv(name: string): string {
  // Vite exposes env vars via import.meta.env
  const value = (import.meta as any).env?.[name];
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

export function getSupabaseBrowser(): SupabaseBrowserClient {
  if (!browserClient) {
    browserClient = createClient<Database>(
      getBrowserEnv("VITE_SUPABASE_URL"),
      getBrowserEnv("VITE_SUPABASE_ANON_KEY")
    );
  }
  return browserClient;
}

// For use cases where you need a fresh client
export function createSupabaseBrowser(): SupabaseBrowserClient {
  return createClient<Database>(
    getBrowserEnv("VITE_SUPABASE_URL"),
    getBrowserEnv("VITE_SUPABASE_ANON_KEY")
  );
}
